export { PersonalEnergyProduction } from './personal-energy-production.component';
